<script setup lang="ts">
    import { initValidators } from '@/services/validators/initialize';
    import TheToastersManager from '@/components/TheToastersManager.vue';
    import TheLoader from '@/components/TheLoader.vue';
    import PreviewBATModal from '@/components/PreviewBATModal.vue';
    import { useAuth } from '@/composables/useAuth';
    import { useConfigStore } from '@/store/config.store';
    import { onMounted, onUnmounted } from 'vue';
    import { storeToRefs } from 'pinia';
    import { useI18n } from 'vue-i18n';
    import { useRoute } from 'vue-router';

    const { t } = useI18n();
    const route = useRoute();

    const { isBATModalVisible } = storeToRefs(useConfigStore());
    const { checkAuth } = useAuth();

    // For more information, see https://vitejs.dev/guide/build#load-error-handling
    function onVitePreloadError() {
        globalThis.location.reload();
    }

    onMounted(() => {
        initValidators();
        checkAuth();
        globalThis.addEventListener('vite:preloadError', onVitePreloadError);
    });
    onUnmounted(() => {
        globalThis.removeEventListener('vite:preloadError', onVitePreloadError);
    });
</script>

<template>
    <TheLoader />
    <router-view />
    <TheToastersManager />
    <!-- Centred so it sits under the canvas rather than across the configuration rail; on
         phones the dock covers it. The back-office carries this line in its own sidebar. -->
    <footer
        v-if="!route.path.startsWith('/admin') || route.path === '/admin/socle'"
        class="pointer-events-none fixed bottom-2 left-0 right-0 flex justify-center px-4"
    >
        <p class="text-xs text-gray-400">
            {{ t('footer_powered_by') }}
            <a
                href="https://www.wanadevdigital.fr"
                target="_blank"
                rel="noopener noreferrer"
                class="pointer-events-auto underline hover:text-gray-600"
                >WanadevDigital</a
            >
        </p>
    </footer>
    <transition
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
        class="duration-300"
    >
        <PreviewBATModal
            v-if="isBATModalVisible"
            @close="isBATModalVisible = false"
        />
    </transition>
</template>

<style>
    #app {
        position: absolute;
        width: 100%;
        /* dvh, not svh: the on-screen keyboard shrinks the page (interactive-widget=
           resizes-content in index.html) and svh ignores it, which pushed the editor's bars
           below the fold and left a white band under them. */
        height: 100dvh;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        touch-action: auto;
    }
</style>
